export default __webpack_public_path__ + "static/globalvillage-9cefca7cb7fef4cbcff377ce3f17f633.webp";